// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606230218/js/" + chunkId + "." + {"44":"fa34b7a3","225":"d8143ce1","481":"0765bc4d","486":"4548de99","770":"42718663"}[chunkId] + ".0.4205974912124357.chunk.js";
};